export var RecommendFriendStateType;
(function (RecommendFriendStateType) {
    RecommendFriendStateType["IN_PROGRESS"] = "in_process";
    RecommendFriendStateType["RECEIVED"] = "received";
    RecommendFriendStateType["CANCELED"] = "canceled";
    RecommendFriendStateType["EXPIRED"] = "expired";
})(RecommendFriendStateType || (RecommendFriendStateType = {}));
//# sourceMappingURL=RecommendFriendStateType.js.map